/**
 * Список образовательных организаций
 */
import { Pagination } from '@n3/ng-api-common';
import { InstitutionShort } from '@n3/ng-api-common';
export class InstitutionList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: InstitutionShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new InstitutionShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
